<script>
  import { Popover } from 'element-ui'
  export default {
    name:'ElPopover',
    extends:Popover
  }
</script>
